// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17fD6","delete":"styles_delete__l1y6n","update":"styles_update__1cXWq","add":"styles_add__1-qH6"};